import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type Asset, type Device } from '../services/assetListService'

export interface AssetDeviceState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null
  assets: Asset[]
  devices: Device[]
}

const initialState: AssetDeviceState = {
  isLoading: true,
  error: null,
  httpStatus: null,
  assets: [],
  devices: []
}

const assetDeviceSlice = createSlice({
  name: 'tiqAssetList',
  initialState,
  reducers: {
    assetDeviceLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        httpStatus: 0,
        assets: [],
        devices: []
      }
    },
    assetDeviceUpdateAction: (state, action: PayloadAction<{ data: { assets?: Asset[], devices?: Device[] }, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: null,
        httpStatus: action.payload.httpStatus,
        assets: action.payload.data.assets ?? [],
        devices: action.payload.data.devices ?? []
      }
    },
    assetDeviceErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        assets: [],
        devices: []
      }
    }
  }
})

export const {
  assetDeviceLoadingAction,
  assetDeviceUpdateAction,
  assetDeviceErrorAction
} = assetDeviceSlice.actions

export default assetDeviceSlice.reducer
